import React from 'react'
import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { globalConfig } from '../../configuration/config'

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
  graphMeEndpoint: `https://graph.microsoft.com/v1.0/me`,
}

export const AuthProvider = (props: any) => {
  const globalConfigData = globalConfig.get()

  const msalConfig = {
    auth: {
      clientId: globalConfigData.clientId,
      authority: globalConfigData.authority,
      redirectUri: globalConfigData.redirectUri,
    },
    cache: {
      cacheLocation: `sessionStorage`, // This configures where your cache will be stored
      storeAuthStateInCookie: false, // Set this to `true` if you are having issues on IE11 or Edge
    },
  }

  const msalInstance = new PublicClientApplication(msalConfig)

  return <MsalProvider instance={msalInstance}>{props.children}</MsalProvider>
}
